import { useSelector } from 'react-redux'
import {
  selectIcbById,
  selectVsicById,
} from './../../../common/category/store/slice'

export const IndustryName = ({ isVSIC, id }) => {
  const name = useSelector(
    isVSIC ? selectVsicById(id, 'name') : selectIcbById(id, 'name'),
  )
  return <span>{name}</span>
}
